(function(W,D){
'use strict';
/*
 * ThermoAspen Stud Spacing Control 1.0.0 — TEMPORARY.
 * A small "Max stud spacing" control in the Frame 3D header on the Construction Drawings page,
 * used until the Specifications section exists. Remove this asset (and its script tag) then.
 *
 * Owns no rules. It writes Construction Spec request overrides.framing.maxStudSpacingMm through
 * ThermoAspenProjectHandoff.patchConstructionSpec(), which validates the request, saves it with the
 * working project (so the Designer and Cutting & Manufacturing read the same value), loads it into
 * the Construction Spec and fires ThermoAspenProjectHandoffUpdated, which rebuilds the Frame 3D
 * viewer and the frame drawings.
 *
 * Requires Construction Spec 1.4.0+ (setMaxStudSpacingMm / maxStudSpacingLimitsMm).
 */
var VERSION='1.0.0',ROOT_ID='ta-stud-spacing-control',tries=0;
if(W.ThermoAspenStudSpacingControlV1&&W.ThermoAspenStudSpacingControlV1.version===VERSION)return;
function spec(){return W.ThermoAspenConstructionSpecV1||null}
function handoff(){return W.ThermoAspenProjectHandoff||null}
function clone(v){try{return JSON.parse(JSON.stringify(v))}catch(e){return v}}
function obj(v){return!!v&&typeof v==='object'&&!Array.isArray(v)}
function limits(){var S=spec(),l=S&&S.maxStudSpacingLimitsMm;return obj(l)?l:{minMm:300,maxMm:600,defaultMm:480,verifiedMm:480}}
function savedRequest(){
  var H=handoff(),r=null;
  try{var rec=H&&typeof H.getRecord==='function'?H.getRecord():null;r=rec&&rec.design&&rec.design.constructionSpec||null}catch(e){r=null}
  if(!obj(r)){var S=spec();r=S&&typeof S.getCurrentRequest==='function'?S.getCurrentRequest():{}}
  return clone(r)||{}
}
function currentValue(){
  var S=spec(),r=savedRequest();
  try{if(S&&typeof S.getMaxStudSpacingMm==='function')return Math.round(S.getMaxStudSpacingMm({constructionSpec:r}))}catch(e){}
  return limits().defaultMm
}
function css(){return '#'+ROOT_ID+'{flex-basis:100%;display:flex;align-items:center;flex-wrap:wrap;gap:6px 8px;margin-top:4px;padding-top:10px;border-top:1px solid var(--line,#d9dfda);font:13px/1.3 system-ui,-apple-system,Segoe UI,Roboto,sans-serif;color:var(--ink,#26362a)}'+
'#'+ROOT_ID+' label{font-weight:700}'+
'#'+ROOT_ID+' .tssc-field,#'+ROOT_ID+' .tssc-actions{display:inline-flex;align-items:center;gap:6px;white-space:nowrap}'+
'#'+ROOT_ID+' input{width:76px;min-height:36px;padding:5px 8px;border:1px solid var(--line,#d9dfda);border-radius:8px;font:inherit;text-align:right}'+
'#'+ROOT_ID+' button{min-height:36px;padding:5px 10px;border:1px solid var(--line,#d9dfda);border-radius:8px;background:#fff;font:inherit;font-weight:700;cursor:pointer}'+
'#'+ROOT_ID+' button[data-act=apply]{background:var(--accent,#3f5c47);border-color:var(--accent,#3f5c47);color:#fff}'+
'#'+ROOT_ID+' button:disabled{opacity:.45;cursor:default}'+
'#'+ROOT_ID+' .tssc-note{flex-basis:100%;font-size:11px;color:var(--muted,#69756c)}'+
'#'+ROOT_ID+' .tssc-note.is-warn{color:#9a5b00}'+
'#'+ROOT_ID+' .tssc-note.is-error{color:#b3261e}'}
function build(host){
  var l=limits(),root=D.createElement('div');root.id=ROOT_ID;root.setAttribute('data-version',VERSION);
  var style=D.createElement('style');style.textContent=css();root.appendChild(style);
  root.insertAdjacentHTML('beforeend',
    '<label for="tssc-input">Max stud spacing</label>'+
    '<span class="tssc-field"><input id="tssc-input" type="number" inputmode="numeric" step="10" min="'+l.minMm+'" max="'+l.maxMm+'" aria-describedby="tssc-note"><span>mm</span></span>'+
    '<span class="tssc-actions"><button type="button" data-act="apply">Apply</button>'+
    '<button type="button" data-act="reset" title="Return to the standard '+l.defaultMm+' mm">Reset</button></span>'+
    '<span id="tssc-note" class="tssc-note" role="status" aria-live="polite"></span>');
  host.appendChild(root);
  var input=root.querySelector('#tssc-input'),note=root.querySelector('#tssc-note'),apply=root.querySelector('[data-act=apply]'),reset=root.querySelector('[data-act=reset]');
  function say(msg,kind){note.textContent=msg||'';note.className='tssc-note'+(kind?' is-'+kind:'')}
  function describe(v){
    if(v===l.verifiedMm)say('Applies to wall studs, rafters and Modern Cube roof joists. Standard '+l.verifiedMm+' mm.');
    else say(v+' mm is not the standard '+l.verifiedMm+' mm — rafter, roof-joist, ceiling and sheathing spans need structural review.','warn');
  }
  function refresh(){var v=currentValue();input.value=String(v);describe(v);sync()}
  function sync(){var v=Math.round(Number(input.value));apply.disabled=!isFinite(v)||v===currentValue();reset.disabled=currentValue()===l.defaultMm}
  function commit(v){
    var S=spec(),H=handoff();
    if(!S||typeof S.setMaxStudSpacingMm!=='function'){say('Construction Spec 1.4.0 or later is required.','error');return}
    if(v!=null&&(!isFinite(v)||v<l.minMm||v>l.maxMm)){say('Enter a value between '+l.minMm+' and '+l.maxMm+' mm.','error');return}
    if(!H||typeof H.patchConstructionSpec!=='function'||typeof H.hasWorkingProject!=='function'||!H.hasWorkingProject()){
      say('Open a project in the Sauna Designer first — the setting is saved with the project.','error');return}
    var q=savedRequest();q.overrides=obj(q.overrides)?q.overrides:{};var f=obj(q.overrides.framing)?q.overrides.framing:{};
    if(v==null)delete f.maxStudSpacingMm;else f.maxStudSpacingMm=v;
    if(Object.keys(f).length)q.overrides.framing=f;else delete q.overrides.framing;
    say('Rebuilding…');apply.disabled=true;reset.disabled=true;
    var ok=false;try{ok=H.patchConstructionSpec(q)!==false}catch(e){ok=false}
    if(!ok){say('Setting rejected — check the value and try again.','error');sync();return}
    refresh();
  }
  apply.addEventListener('click',function(){commit(Math.round(Number(input.value)))});
  reset.addEventListener('click',function(){commit(null)});
  input.addEventListener('input',sync);
  input.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();if(!apply.disabled)apply.click()}});
  ['ThermoAspenProjectHandoffUpdated','ThermoAspenProjectHandoffApplied','ThermoAspenProjectHandoffReady','ThermoAspenConstructionSpecReady'].forEach(function(t){W.addEventListener(t,function(){if(D.activeElement!==input)refresh()})});
  refresh();
  return root
}
function mount(){
  if(D.getElementById(ROOT_ID))return;
  var viewer=D.getElementById('ta-structural-wall-3d'),host=viewer&&viewer.querySelector('.ta3-head');
  if(!host){if(tries++<60)setTimeout(mount,500);return}
  build(host)
}
W.ThermoAspenStudSpacingControlV1={version:VERSION,temporary:true,mount:mount};
if(D.readyState==='loading')D.addEventListener('DOMContentLoaded',mount);else mount();
})(window,document);
